<template>
  <b-card>

    <!-- form -->
    <validation-observer ref="modelsCreate">
      <b-form>
        <b-row>
          <b-col md="12">
            <b-overlay
              :show="loading"
              rounded
              opacity="0.5"
              spinner-small
              spinner-variant="primary"
            >
              <div class="section-block mb-4">
                <div class="section-block__title">
                  <feather-icon
                    icon="GlobeIcon"
                    width="24"
                    height="24"
                  />
                  <h2>CELL Info</h2>
                </div>
                <div class="neighbouring-form-container">
                  <b-form-group
                    label="Current Operator:"
                    label-class="label-class"
                    class="neighbouring-form-group"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Current Operator:"
                      vid="operator"
                      rules="max:255"
                    >
                      <b-form-input
                        v-model="form.operator"
                        disabled
                        :state="errors.length > 0 ? false:null"
                        placeholder="N/A"
                        autocomplete="off"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    v-if="form.hardware_model ? form.hardware_model.manufacturer.name === 'Four Faith' : false"
                    label="Cell Identifier:"
                    label-class="label-class"
                    class="neighbouring-form-group"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="ENB ID:"
                      vid="enbId"
                      rules="max:255"
                    >
                      <b-form-input
                        v-model="form.enbId"
                        disabled
                        :state="errors.length > 0 ? false:null"
                        placeholder="N/A"
                        autocomplete="off"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    v-else
                    label="ENB ID:"
                    label-class="label-class"
                    class="neighbouring-form-group"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="ENB ID:"
                      vid="enbId"
                      rules="max:255"
                    >
                      <b-form-input
                        v-model="form.enbId"
                        disabled
                        :state="errors.length > 0 ? false:null"
                        placeholder="N/A"
                        autocomplete="off"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    label="4G Physical Cell ID:"
                    label-class="label-class"
                    class="neighbouring-form-group"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="4G Physical Cell ID"
                      vid="physicalCellId"
                      rules="max:255"
                    >
                      <b-form-input
                        v-model="form.physicalCellId"
                        disabled
                        :state="errors.length > 0 ? false:null"
                        placeholder="N/A"
                        autocomplete="off"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div class="neighbouring-form-container">
                  <b-form-group
                    v-if="form.hardware_model && form.hardware_model.manufacturer.name === 'MikroTik'"
                    label="SIM Tel. No.:"
                    label-class="label-class"
                    class="neighbouring-form-group"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="SIM Tel. No:"
                      vid="subscriberNumber"
                      rules="max:255"
                    >
                      <b-form-input
                        v-model="form.subscriberNumber"
                        disabled
                        :state="errors.length > 0 ? false:null"
                        placeholder="N/A"
                        autocomplete="off"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    v-else
                    label="SIM serial:"
                    label-class="label-class"
                    class="neighbouring-form-group"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="SIM serial:"
                      vid="sectorId"
                      rules="max:255"
                    >
                      <b-form-input
                        v-model="form.sectorId"
                        disabled
                        :state="errors.length > 0 ? false:null"
                        placeholder="N/A"
                        autocomplete="off"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    label="PCI:"
                    label-class="label-class"
                    class="neighbouring-form-group"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Session Uptime:"
                      vid="sessionUptime"
                      rules="max:255"
                    >
                      <b-form-input
                        v-model="form.sessionUptime"
                        disabled
                        :state="errors.length > 0 ? false:null"
                        placeholder="N/A"
                        autocomplete="off"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div class="neighbouring-form-container">
                  <b-form-group
                    label="Primary Band:"
                    label-class="label-class"
                    class="neighbouring-form-group"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Primary Band:"
                      vid="primaryBand"
                      rules="max:255"
                    >
                      <b-form-input
                        v-model="form.primaryBand"
                        disabled
                        :state="errors.length > 0 ? false:null"
                        placeholder="N/A"
                        autocomplete="off"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    v-if="form.caBand"
                    label="CA Band:"
                    label-class="label-class"
                    class="neighbouring-form-group"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="CA Band:"
                      vid="caBand"
                      rules="max:255"
                    >
                      <b-form-input
                        v-model="form.caBand"
                        disabled
                        :state="errors.length > 0 ? false:null"
                        placeholder="N/A"
                        autocomplete="off"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div class="d-flex w-100 chart-container">
                  <b-card
                    no-body
                    class="p-0"
                  >
                    <Chart
                      id="RSSI"
                      :traffic="RSIITraffic"
                      title="RSSI"
                      unit="dBm"
                      :raw-traffic="rawTraffic.rssi"
                    />
                  </b-card>
                  <b-card
                    no-body
                    class="p-0"
                  >
                    <Chart
                      id="RSRP"
                      :traffic="RSRPTraffic"
                      title="RSRP"
                      unit="dBm"
                      :raw-traffic="rawTraffic.rsrp"
                    />
                  </b-card>
                </div>
                <div class="d-flex w-100 chart-container">
                  <b-card
                    no-body
                    class="p-0"
                  >
                    <Chart
                      id="SINR"
                      :traffic="SINRTraffic"
                      title="SINR"
                      unit="dB"
                      :raw-traffic="rawTraffic.sinr"
                    />
                  </b-card>
                  <b-card
                    no-body
                    class="p-0"
                  >
                    <Chart
                      id="RSRQ"
                      :traffic="RSRQTraffic"
                      title="RSRQ"
                      unit="dB"
                      :raw-traffic="rawTraffic.rsrq"
                    />
                  </b-card>
                </div>
              </div>
            </b-overlay>
          </b-col>
          <!-- submit button -->
          <b-col
            cols="12"
            class="text-right buttons-container__left"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              ok-variant="secondary"
              @click.prevent="backToSite"
            >
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <b-modal
      id="cannotConnect"
      ref="cannotConnect"
      title="Connection Error"
      centered
      ok-only
      ok-variant="secondary"
      ok-title="Back to Hardware"
      hide-close
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      @ok="backToSite"
    >
      <div class="mt-2 mb-2">
        <p>We couldn't connect to the device to fetch CELL Info. Please ensure the device is online and try again.</p>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BCard, VBToggle, BFormInput, BFormGroup, BForm, BButton, BOverlay,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import axios from '../../axios-resolver'
import Chart from './Chart.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BCard, Chart, BFormInput, BFormGroup, BForm, ValidationProvider, ValidationObserver, BButton, BOverlay,
  },
  data() {
    return {
      siteId: this.$route.params.id,
      wifiItems: [],
      loading: true,
      visitedTabs: [],
      isActive: false,
      hardwareId: this.$route.params.hardwareId,
      RSIITraffic: [],
      RSRPTraffic: [],
      SINRTraffic: [],
      RSRQTraffic: [],

      rawTraffic: {
        sinr: '',
        rssi: '',
        rsrp: '',
        rsrq: '',
      },

      form: {
        ssid: '',
        operator: '',
        enbId: '',
        sectorId: '',
        sessionUptime: '',
        physicalCellId: '',
        primaryBand: '',
        subscriberNumber: '',
      },
    }
  },
  beforeDestroy() {
    this.isActive = false
  },
  created() {
    // interval to add random traffic
    // hardwareId
    this.isActive = true
    setInterval(() => {
      if (this.isActive) {
        this.fetchGraphs()
      }
    }, 3_000)
    this.fetchTextFields()
  },
  methods: {
    backToSite() {
      this.$router.push({ name: 'site-summary', params: { id: this.siteId } })
    },
    async fetchTextFields() {
      try {
        const { data } = await axios.get(`/hardware/control/${this.hardwareId}/lte/statistic`)
        this.form = data.data
      } catch (error) {
        console.warn(error)
        this.$refs.cannotConnect.show()
      } finally {
        this.loading = false
      }
    },
    async fetchGraphs() {
      this.isActive = false
      try {
        const { data: { data } } = await axios.get(`/hardware/control/${this.hardwareId}/lte/statistic/signals`)
        this.RSIITraffic = [data.rssi]
        this.RSRPTraffic = [data.rsrp]
        this.SINRTraffic = [data.sinr]
        this.RSRQTraffic = [data.rsrq]
        this.rawTraffic = data
        this.isActive = true
      } catch (error) {
        this.isActive = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
.card{
    &-header{
        padding: 0 !important;
    }
}
</style>
